import React, { lazy, Suspense, useEffect, useState } from "react";
import "./V2_headerTab.css";
import { Pivot, PivotItem, Stack } from "@fluentui/react";
import { InjectedIntlProps, injectIntl } from "react-intl";
import { useLocation, useHistory } from "react-router-dom";
import { SETChileComponentName, SETHasServiceRequestTypeLogData, SETIsCustomeLog, SETLogEventData, setIsBotError, setIsLoader, settitleLoaderName } from "../../../../core/store";
import { useDispatch } from "react-redux";
import { lazyRetry } from "../../../utils/utils";
import { getConsumptionAPI } from "../../../utils/httpUtils";
import { isFeatureEnabled } from "../../../services/FeatureFlagService";
import { DEFAULT_MCAPS_COPILOT_FEATURE_FLAG } from "../../copilot/defaultAgent";
import { ServiceContext } from "@msx/platform-services";
const ErrorPopUpMessage = lazy(() => lazyRetry(() => import(".././ErrorPopUpMessage")));

const AnnouncementBanner = lazy(() =>
  lazyRetry(() =>
    import('../../banner/AnnouncementBanner').then(module => ({ default: module.AnnouncementBanner }))
  )
);

const Message = lazy(() => lazyRetry(() => import("../../main/Messages/messages")));

export interface HeaderTabProp extends InjectedIntlProps {
  myHelpWorkspaceComponent: React.ReactNode;
  catalogComnponent: React.ReactNode;
  feedbackTabComponent: React.ReactNode;
  ticketsComponent: React.ReactNode;
  activeTabKey: string;
  setActiveTabKey?: any;
  currentUserData: any;
  showErrorModal: any;
  setShowErrorModal: any;
  refreshHeaderTabCount: boolean;
}

const HeaderTab: React.FC<HeaderTabProp> = (props) => {

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    setMyHelpTileCount(sessionStorage.getItem("MyHelp_Tile_Count"));
    setTotalCount(sessionStorage.getItem("totalCount"));
    fetchFeedbackTabName();
  }, [props.refreshHeaderTabCount]);

  let { showErrorModal } = props;
  let irisBot = false;
  const reduxDispatch = useDispatch();
  const context = React.useContext(ServiceContext);
  // When the default MCAPS Copilot agent is enabled, IRIS is no longer the
  // default agent on the My Help Workspace tab, so returning to that tab must
  // not force the IRIS loader / IRIS mount.
  const isDefaultMcapsCopilotEnabled = isFeatureEnabled(
    DEFAULT_MCAPS_COPILOT_FEATURE_FLAG
  );

  const [isitemKey, setIsitemKey] = useState(false);
  const [myHelpTileCount, setMyHelpTileCount] = useState(sessionStorage.getItem("MyHelp_Tile_Count"));
  const [totalCount, setTotalCount] = useState(sessionStorage.getItem("totalCount"));
  const [feedbackTabName, setFeedbackTabName] = useState("My Voice"); // Default fallback

  // Function to fetch feedback tab name from API with session storage caching
  const fetchFeedbackTabName = async () => {
    try {
      // Step 1: Check session storage first
      const cachedTabName = sessionStorage.getItem("Feedback_Tab_Name");
      if (cachedTabName) {
        setFeedbackTabName(cachedTabName);
        return;
      }

      // Step 2: If not in session storage, call the API
      if (context?.authClient) {
        const response = await getConsumptionAPI('/api/FeedbackPage/TabName', context.authClient);
        
        if (response?.status === 200 && response?.data) {
          const tabName = response.data;
          // Store in session storage
          sessionStorage.setItem("Feedback_Tab_Name", tabName);
          setFeedbackTabName(tabName);
        } else {
          // Use default if API fails
          setFeedbackTabName("My Voice");
        }
      } else {
        // Use default if no auth context
        setFeedbackTabName("My Voice");
      }
    } catch (error) {
      console.error('Error fetching feedback tab name:', error);
      // Use default on error
      setFeedbackTabName("My Voice");
    }
  };

  // Sync tab selection with URL (for direct navigation like /mytickets or /myvoice)
  // Note: we only depend on location.pathname so user tab clicks are not
  // continually overridden by a changing setActiveTabKey function reference.
  useEffect(() => {
    const raw = location.pathname || "";
    const normalized = raw.replace(/\/+$/, "").toLowerCase();
    const segments = normalized.split("/");
    const lastSegment = segments[segments.length - 1];

    if (lastSegment === "mytickets" && props.setActiveTabKey) {
      props.setActiveTabKey("2");
    } else if (lastSegment === "myvoice" && props.setActiveTabKey) {
      props.setActiveTabKey("3");
    }
  }, [location.pathname]);

  const TAB_MYHELP_WORKSPACE = "My Help Workspace";
  const TAB_CATALOG = "All MCAPSHelp Catalog";
  const TAB_FEEDBACK = feedbackTabName; // Now dynamic
  const TAB_TICKETS = "My Tickets";
  const catalogTileCount = sessionStorage.getItem("Catalog_Tile_Count");
  const getActivePage = () => {
    let pagename = "";
    switch (props.activeTabKey) {
      case "0":
        pagename = TAB_MYHELP_WORKSPACE
        break;
      case "1":
        pagename = TAB_CATALOG
        break;
      case "2":
        pagename = TAB_TICKETS
        break;
      case "3":
        pagename = TAB_FEEDBACK
        break;
      default:
        break;
    }
    return pagename
  }
  const setActiveTabKeyinHeaderTab = (item?: PivotItem) => {
    // If user navigated via /mytickets deep link, normalize the URL
    // back to root on any tab click. This keeps /mytickets as a
    // URL-only entry point and prevents tabs from leaving it stuck
    // in the address bar.
    const rawPath = location.pathname || "";
    const normalized = rawPath.replace(/\/+$/, "").toLowerCase();
    const segments = normalized.split("/");
    const lastSegment = segments[segments.length - 1];

    if (lastSegment === "mytickets") {
      history.replace("/");
    }

    if (item.props.itemKey === "0") {
      if (isDefaultMcapsCopilotEnabled) {
        // MCAPS Copilot is the default agent on this tab; do not trigger the
        // IRIS loader/mount. The header re-opens MCAPS Copilot on tab return.
        setIsitemKey(false);
        reduxDispatch(setIsLoader(false));
      } else {
        irisBot = false;
        setIsitemKey(true)
        checkIris();
        reduxDispatch(setIsLoader(true));
      }
    }
    else {
      setIsitemKey(false)
      reduxDispatch(setIsLoader(false));
    }
    reduxDispatch(settitleLoaderName(""));
    reduxDispatch(setIsBotError(false));
    //Start Event Logging 
    reduxDispatch(SETChileComponentName(getActivePage()));
    reduxDispatch(SETHasServiceRequestTypeLogData(true));
    reduxDispatch(SETLogEventData(
      {
        elementName: `${item.props.headerText} Tab`,
        elementId: "",
        action: "click",
        message: `User click on ${item.props.headerText} Tab `,
        profileSetting: `v2`,
      }
    ));

    reduxDispatch(SETIsCustomeLog(true));

    //End Event Logging
    props.setActiveTabKey(item.props.itemKey!);
  };
  const checkIris = () => {
    if (isitemKey) {
      if (!irisBot) {
        const irisMenu = document.querySelector(".ms-layer");
        if (irisMenu !== null) {
          reduxDispatch(setIsLoader(false));
          irisBot = true;
        } else {
          if (props.activeTabKey === '0') {
            reduxDispatch(setIsLoader(true));
          }
          else {
            reduxDispatch(setIsLoader(false));
          }
          setTimeout(checkIris, 30);
        }
      }
      else {
        reduxDispatch(setIsLoader(false));
      }
    }
  };

  const renderMain = (): JSX.Element => {
    return (
      <>
        {showErrorModal["isErrorModalVisible"] && (
          <Suspense fallback={<></>}>
            {" "}
            <ErrorPopUpMessage
              message={showErrorModal["errorMessage"]}
              isWorkspaceView={props.activeTabKey === "0"}
            />{" "}
          </Suspense>
        )}

        <Suspense fallback={<></>}>
          {" "}
          <Message type="success" />
          <AnnouncementBanner
            currentUserData={props.currentUserData}
            isWorkspaceView={props.activeTabKey === "0"}
          />
        </Suspense>
        <Stack className="PivotHeaderContainer">
          <Pivot
            aria-label="Top navigation"
            selectedKey={props.activeTabKey}
            onLinkClick={setActiveTabKeyinHeaderTab}
            className="PivotClass"
            style={{ marginTop: "15px" }}>
            <PivotItem
              headerText={`${TAB_MYHELP_WORKSPACE} (${myHelpTileCount ? myHelpTileCount : 0})`}
              headerButtonProps={{
                "data-order": 1,
                "data-title": TAB_MYHELP_WORKSPACE,
              }}
              itemKey="0">
              <>{props.myHelpWorkspaceComponent}</>
            </PivotItem>
            <PivotItem
              headerText={`${TAB_CATALOG} (${catalogTileCount ? catalogTileCount : 0})`}
              headerButtonProps={{
                "data-order": 2,
                "data-title": TAB_CATALOG,
              }}
              itemKey="1">
              <>{props.catalogComnponent}</>
            </PivotItem>
            <PivotItem 
              style={{ width: "80%", paddingBottom: "40px" }} 
              headerText={`${TAB_TICKETS} (${totalCount ? totalCount : 0})`} 
              headerButtonProps={{
                "data-order": 3,
                "data-title": TAB_TICKETS,
              }}
              itemKey="2">
              {props.ticketsComponent}
            </PivotItem>
            <PivotItem
              headerText={TAB_FEEDBACK}
              headerButtonProps={{
                "data-order": 4,
                "data-title": TAB_FEEDBACK,
              }}
              itemKey="3">
              <>{props.feedbackTabComponent}</>
            </PivotItem>
          </Pivot>
        </Stack>
      </>
    );
  };
  return renderMain();
};

export const V2_HeaderTabNav = injectIntl(HeaderTab);

// Generated by Copilot
// updated on: 2025-10-14 | 35 lines added/updated | Auto Generated | Added dynamic feedback tab name functionality with API integration, session storage caching, and tab reordering for feedback component | Time Taken 7 min
// updated on: 2025-10-15 | 25 lines updated | Auto Generated | Moved feedback tab to last position (index 3) after tickets tab per business requirements | Time Taken 5 min
